var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pt-2 pl-3 ma-2",attrs:{"width":"320px","height":"330px"}},[_c('div',{staticClass:"overline grey--text text-uppercase"},[_vm._v("Calendar")]),_c('v-date-picker',{staticClass:"elevation-0",attrs:{"no-title":""},model:{value:(_vm.picker),callback:function ($$v) {_vm.picker=$$v},expression:"picker"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }